module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAJ1BMVEUuMDArLS0uMDAuMDAuMDAuMDAuMDAuMDArLS0uMDAAAAArLS0uMDAiNsLtAAAAC3RSTlMb4AkSeDCWWtcGAEaHSKgAAABASURBVHja1c47DgAgCANQ/KCi3P+8ElwEEnc7vgRamDH/WuWTfhktpWFuuxraf0OouQ4UA9/buIYtJVHcl5+bN3jRDgCZFjPCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_desc.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_desc.png
// module chunks = 2